import PromocodesService from '@/api/PromocodesService.js'
import Vue from 'vue'
export const promocodesModule = {
  namespaced: true,
  state: () => ({
    promocodesData: [],
    promocodesLoadStatus: 'request',
    paginationPromocodesStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPromocodesStateParams.total /
        state.paginationPromocodesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.promocodesData = [...data]
    },
    create(state, data) {
      state.promocodesData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.promocodesData.findIndex(
        (x) => x.promocodes__id == data.id
      )
      Object.assign(state.promocodesData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.promocodesData.findIndex(
        (x) => x.promocodes__id == id
      )
      state.promocodesData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPromocodesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.promocodesLoadStatus = 'request'
    },
    load_success(state) {
      state.promocodesLoadStatus = 'success'
    },
    load_error(state) {
      state.promocodesLoadStatus = 'error'
    }
  },
  actions: {
    getPromocodesAll({ commit }, params) {
      commit('load_request')

      PromocodesService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createPromocodesData({ commit }, createData) {
      PromocodesService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editPromocodesMultiple({ commit }, { id, dataEdit }) {
      PromocodesService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deletePromocodesData({ commit }, id) {
      // commit("load_request");
      PromocodesService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
